import { combineReducers } from "redux";
import type { PreviousSaleState } from "../../Actions/SellScreen/SellScreenActions";
import type { ClassificationState } from "../../Actions/SellScreen/SellScreenClassificationActions";
import SellScreenActionSummaryReducer, { type SummaryState } from "./SellScreenActionSummaryReducer";
import SellScreenClassificationReducer from "./SellScreenClassificationReducer";
import SellScreenMiscellaneousReducer, { type MiscellaneousState } from "./SellScreenMiscellaneousReducer";
import SellScreenMobileReducer, { type MobileState } from "./SellScreenMobileReducer";
import SellScreenModeReducer, { type SellScreenModeState } from "./SellScreenModeReducer";
import SellScreenPreviousSaleReducer from "./SellScreenPreviousSaleReducer";
import SellScreenPromotionsReducer, { type PromotionsState } from "./SellScreenPromotionsReducer";
import SellScreenSaleKeysReducer, { type SaleKeysState } from "./SellScreenSaleKeysReducer";
import SellScreenSaleReducer from "./SellScreenSaleReducer";
import type { SaleState } from "./SellScreenSaleReducerTypes";
import SellScreenSearchReducer, { type SearchState } from "./SellScreenSearchReducer";

export interface SellScreenState {
    sale: SaleState;
    previousSale: PreviousSaleState;
    search: SearchState;
    mobile: MobileState;
    modes: SellScreenModeState;
    summary: SummaryState;
    saleKeys: SaleKeysState;
    classification: ClassificationState;
    miscellaneous: MiscellaneousState;
    promotions: PromotionsState;
}

const SellScreenReducer = combineReducers<SellScreenState>({
    sale          : SellScreenSaleReducer,
    previousSale  : SellScreenPreviousSaleReducer,
    search        : SellScreenSearchReducer,
    mobile        : SellScreenMobileReducer,
    modes         : SellScreenModeReducer,
    summary       : SellScreenActionSummaryReducer,
    saleKeys      : SellScreenSaleKeysReducer,
    classification: SellScreenClassificationReducer,
    miscellaneous : SellScreenMiscellaneousReducer,
    promotions    : SellScreenPromotionsReducer,
});

export default SellScreenReducer;
